import moment from 'moment';

export const ORDER_DELIVERY_FREEZE_DAYS = 12;
export const DELIVERY_FREEZE_ERROR =
  'Changes to orders are not allowed within 12 days of the delivery date.';

export const getDaysUntilDelivery = (date) => {
  if (!date) return null;
  return moment(date).startOf('day').diff(moment().startOf('day'), 'days');
};

export const isDeliveryDateFrozen = (date) => {
  const daysUntil = getDaysUntilDelivery(date);
  if (daysUntil === null) return false;
  return daysUntil <= ORDER_DELIVERY_FREEZE_DAYS;
};

export const getEarliestUnfrozenDeliveryDate = () =>
  moment().startOf('day').add(ORDER_DELIVERY_FREEZE_DAYS + 1, 'days');

export const orderIsDeliveryFrozen = (order) => {
  if (!order) return false;
  if (typeof order.isDeliveryFrozen === 'boolean') {
    return order.isDeliveryFrozen;
  }
  return isDeliveryDateFrozen(order.DeliveryDate);
};
